export default {
  COMMERCIAL: 1,
  LABORATORY: 4
}
